import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { copyText } from '@/lib/browser';

export function CopyButton({ value, label = true }: { value: string; label?: boolean }) {
  const [done, setDone] = useState(false);
  const copy = () => void copyText(value).then(() => { setDone(true); setTimeout(() => setDone(false), 1500); });
  return (
    <Button variant="outline" size={label ? 'sm' : 'icon-xs'} type="button" onClick={copy} aria-label="Copy">
      {done ? <Check className="text-success" /> : <Copy />}
      {label && (done ? 'Copied' : 'Copy')}
    </Button>
  );
}
